'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', '$routeParams', '$window', 'UnitService', function($scope, $routeParams, $window, UnitService) {
    $scope.units = [];
    UnitService.api.get({
                            filters: [`'status' EQ 'ENABLED'`],
                            sorts: ['name:ASC'],
                        }, (data) => $scope.units = data._embedded);
}];
